import { EllipsedText, FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { LabelMedium } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { LiveStatusConvoyDetail } from '../../../types/liveStatus';
import { StyledTooltip } from '../../ui/StyledTooltip';

type Props = {
  liveStatusConvoyDetail: LiveStatusConvoyDetail;
};
function ConvoyDetailCardHeader({ liveStatusConvoyDetail }: Readonly<Props>) {
  const { theme, css, classes } = useStyles();

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.sizing.scale500} ${theme.sizing.scale600}`,
      })}
    >
      <FlexRow gap={theme.sizing.scale200}>
        <StyledTooltip content={'Nombre'}>
          <LabelMedium>
            <EllipsedText
              breakAll
              inline
            >
              {liveStatusConvoyDetail.name}
            </EllipsedText>
          </LabelMedium>
        </StyledTooltip>
      </FlexRow>
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={classes.centeredStart}
      >
        <StyledTooltip content={liveStatusConvoyDetail.active ? 'Activo' : 'No activo'}>
          <MaterialIcon
            name="directions_car"
            warn={!liveStatusConvoyDetail.active}
            success={!!liveStatusConvoyDetail.active}
          />
        </StyledTooltip>
      </FlexRow>
    </FlexRow>
  );
}

export default memo(ConvoyDetailCardHeader);
